import React, { useEffect, useState } from 'react'
import classes from "./style.module.scss";
import { useNavigate } from 'react-router-dom';
import TableWrapper from '../../../../component/TableWrapper';
import { Icons } from '../../../../assets';
import Exported from '../../../../service/endpoints';
import request from '../../../../service';
import { Toast } from '../../../../service/toast';
import moment from 'moment';
import config from '../../../../service/env';
import { useDispatch } from 'react-redux';
import { saveLoadingState } from '../../../../redux/reducers/loadingSlice';


const QrcodeTable = (props) => {

    const { searchInput, activeTab, setSelectedInfo, setQRSetupModal } = props
    const [page, setPage] = useState(1);
    const [userList, setUserList] = useState({});
    const [isLoading, setisLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState(null);
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const { apiUrl } = config

    const userHeader = [
        { label: "File Name" },
        { label: "Quantity" },
        { label: "Date Created" },
        { label: "Actions" },
    ]

    const getUserList = async () => {
        setisLoading(true)
        let url = `${Exported.Endpoints.getQRList}`
        let paramsObj = {
            page: page,
            limit: 10,
            isBulk: activeTab === 'Individual' ? 0 : 1
        }

        if (searchInput && searchInput !== '') {
            paramsObj['search'] = searchInput
        }
        if (sortConfig) {
            paramsObj['sort'] = sortConfig?.key
            paramsObj['sortOrder'] = sortConfig?.direction
        }

        await request({
            url: url,
            params: { ...paramsObj }
        }).then((res) => {
            if (res?.data?.status) {
                const obj = {
                    result: res?.data?.data?.list,
                    pageMeta: res?.data?.data?.pageMeta
                }
                setUserList(obj)
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        setisLoading(false)
    }

    useEffect(() => {
        getUserList()
    }, [page, activeTab, searchInput])

    const handleData = (keyValue, defaultValue, className = '') => {
        return (
            <td className={`${className}`}>{keyValue ? keyValue : defaultValue}</td>
        )
    };

    const redirectTo = (id) => {
        navigate(`?id=${id}`);
    };

    const downloadQR = (item) => {
        dispatch(saveLoadingState(true))
        let endpoint = 'download_qr'
        //they want to download invidual qr for the bulk qr one so i comment this
        // let endpoint = activeTab == 'Bulk' ? 'download_bulk_qr' : 'download_qr'
        window.open(`${apiUrl}/qrcode/${endpoint}?id=${item?.id}`, "_blank")
        dispatch(saveLoadingState(false))
    }


    return (
        <>
            <div className={`eventWrapper`}>
                <div className={`mt-2 mb-5 ${classes.adminTableWrapper}`}>
                    <TableWrapper
                        headerDetails={userHeader}
                        pageMeta={userList?.pageMeta}
                        handlePageChange={setPage}
                        listLength={userList?.result || []}
                        isLoading={isLoading}
                        sortConfig={sortConfig}
                        setSortConfig={setSortConfig}
                    >
                        {userList?.result?.map((item, index) => {
                            const { id = '', fileName="", quantity = '', createdAt = '' } = item;
                            return (
                                <tr key={id}>
                                    {handleData(fileName, '-', 'text-center')}
                                    {handleData(quantity, '-', 'text-center')}
                                    <td className=" px-3 mx-auto text-center">
                                        <div>
                                            {createdAt ? moment(createdAt).format('DD MMM YYYY') : '-'}
                                        </div>
                                    </td>
                                    <td className=" px-3 mx-auto text-center action-button">
                                        <div className='flex items-center justify-center'>
                                            {/* <img src={Icons.eye} alt='View' className='cursor-pointer w-[20px] h-[20px]' onClick={() => { setSelectedInfo(item); redirectTo(id) }} /> */}
                                            <img src={Icons.downloadIcon} alt='Download' className='cursor-pointer w-[18px] h-[18px] mx-2' onClick={() => downloadQR(item)} />
                                            {/* <img src={Icons.delete} alt='Delete' className='cursor-pointer w-[20px] h-[20px]' /> */}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </TableWrapper>
                </div>
            </div>
        </>
    )
}

export default QrcodeTable